<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21.073"
        height="20.149"
        viewBox="0 0 21.073 20.149"
    >
        <g id="Star" transform="translate(0.76 0.75)">
            <path
                id="Pfad_323"
                data-name="Pfad 323"
                d="M10.887.974,13.6,6.465a.4.4,0,0,0,.3.219l6.059.881a.4.4,0,0,1,.223.685L15.8,12.524a.4.4,0,0,0-.116.356l1.035,6.035a.4.4,0,0,1-.583.423l-5.419-2.849a.405.405,0,0,0-.374,0L4.92,19.338a.4.4,0,0,1-.583-.423L5.372,12.88a.4.4,0,0,0-.116-.356L.872,8.25A.4.4,0,0,1,1.1,7.565l6.059-.881a.4.4,0,0,0,.3-.219L10.166.974A.4.4,0,0,1,10.887.974Z"
                transform="translate(-0.75 -0.75)"
                :class="
                    strokeClass +
                        ' transition-stroke ' +
                        fillClass +
                        ' transition-fill'
                "
                stroke-linecap="round"
                stroke-miterlimit="10"
                stroke-width="1.5"
            />
        </g>
    </svg>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
    name: "StarIcon",
    props: {
        fillClass: {
            type: String,
            required: true,
        },
        strokeClass: {
            type: String,
            required: true,
        },
    },
});
</script>
